<template>
  <div>
    <Grid
      :service="service"
      route_name="user_access_logs"
      order_column="login_at"
      direction="desc"
      hide_actions="true"
      :css_formats="{
        status: (status, model) => {
          if (status === 'success') {
            return 'badge badge-glow badge-success'
          } else if (status === 'failed') {
            return 'badge badge-glow badge-danger'
          } else if (status === 'unauthorized') {
            return 'badge badge-glow badge-warning'
          }
          return ''
        }
      }"
      :column_formats="{
        status: val => {
          if (val === 'success') {
            return this.$t('last_access.status.success')
          } else if (val === 'failed') {
            return this.$t('last_access.status.failed')
          } else if (val === 'unauthorized') {
            return this.$t('last_access.status.unauthorized')
          }
          return val || ''
        }
      }"
    >
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td key="status">
            <div :class="getStatusCss(tr.status)">
              {{ getStatusText(tr.status) }}
            </div>
          </vs-td>
          <vs-td key="email">
            <div>{{ tr.email || '' }}</div>
          </vs-td>
          <vs-td key="user_name">
            <div>{{ (tr.user && tr.user.name) || '' }}</div>
          </vs-td>
          <vs-td key="ip_address">
            <div>{{ tr.ip_address || '' }}</div>
          </vs-td>
          <vs-td key="device_type">
            <div>{{ tr.device_type || '' }}</div>
          </vs-td>
          <vs-td key="browser">
            <div>{{ tr.browser || '' }}</div>
          </vs-td>
          <vs-td key="platform">
            <div>{{ tr.platform || '' }}</div>
          </vs-td>
          <vs-td key="login_at_formatted">
            <div>{{ tr.login_at_formatted || '' }}</div>
          </vs-td>
          <vs-td key="logout_at_formatted">
            <div>{{ tr.logout_at_formatted || '' }}</div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import UserAccessLogService from '@/services/api/UserAccessLogService'

export default {
  components: {
    Grid
  },
  data: () => ({
    service: null
  }),
  methods: {
    getStatusCss(status) {
      if (status === 'success') {
        return 'badge badge-glow badge-success'
      } else if (status === 'failed') {
        return 'badge badge-glow badge-danger'
      } else if (status === 'unauthorized') {
        return 'badge badge-glow badge-warning'
      }
      return ''
    },
    getStatusText(status) {
      if (status === 'success') {
        return this.$t('last_access.status.success')
      } else if (status === 'failed') {
        return this.$t('last_access.status.failed')
      } else if (status === 'unauthorized') {
        return this.$t('last_access.status.unauthorized')
      }
      return status || ''
    }
  },
  beforeMount() {
    this.service = UserAccessLogService.build(this.$vs)
  }
}
</script>
